import { render, staticRenderFns } from "./CatalogoTratamientos.vue?vue&type=template&id=61bc8a7e&scoped=true"
import script from "./CatalogoTratamientos.vue?vue&type=script&lang=js"
export * from "./CatalogoTratamientos.vue?vue&type=script&lang=js"
import style0 from "./CatalogoTratamientos.vue?vue&type=style&index=0&id=61bc8a7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bc8a7e",
  null
  
)

export default component.exports